import { render, staticRenderFns } from "./LoginFormPhoneVerification.vue?vue&type=template&id=02dffade&scoped=true&"
import script from "./LoginFormPhoneVerification.vue?vue&type=script&lang=js&"
export * from "./LoginFormPhoneVerification.vue?vue&type=script&lang=js&"
import style0 from "./LoginFormPhoneVerification.vue?vue&type=style&index=0&id=02dffade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dffade",
  null
  
)

export default component.exports